// This icon file is generated automatically.
var PStopOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81a5.81 5.81 0 01-4.5-9.48l8.17 8.18c-1 .81-2.28 1.3-3.67 1.3zm4.5-2.14L3.34 2.49a5.81 5.81 0 018.18 8.18z", "fill-rule": "nonzero" } }] }, "name": "p-stop", "theme": "outlined" };
export default PStopOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PStopOutlined.js
// module id = 3658
// module chunks = 0